import React from "react";

const STAGGER = 300;

const REVEAL_COLORS = {
  correct: "var(--numex-green)",
  present: "var(--numex-gold)",
  absent: "var(--numex-absent)",
};

function Tile({ char, status, mode, animate, delay }) {
  // mode: "empty" | "filled" | "revealed"
  let className = "numex-tile";
  const style = {};

  if (mode === "filled") {
    className += " numex-tile-filled";
  } else if (mode === "revealed") {
    if (animate) {
      className += " numex-tile-reveal";
      style["--reveal-color"] = REVEAL_COLORS[status];
      style.animationDelay = `${delay}ms`;
    } else {
      className += ` numex-tile-${status}`;
    }
  }

  return (
    <div
      className={className}
      style={style}
      data-testid={`tile-${char || "empty"}`}
      data-status={mode === "revealed" ? status : "none"}
    >
      {char}
    </div>
  );
}

export default function Grid({
  rowCount,
  colCount,
  guesses,
  currentGuess,
  revealRow,
  revealCount,
  shakeRow,
}) {
  const rows = [];

  for (let r = 0; r < rowCount; r++) {
    const tiles = [];
    const submitted = guesses[r];
    const isActiveRow = !submitted && r === guesses.length;
    const isShake = shakeRow === r;

    for (let c = 0; c < colCount; c++) {
      if (submitted) {
        const char = submitted.digits[c];
        const status = submitted.feedback[c];
        const isRevealing = r === revealRow;
        tiles.push(
          <Tile
            key={c}
            char={char}
            status={status}
            mode="revealed"
            animate={isRevealing}
            delay={c * STAGGER}
          />
        );
      } else if (isActiveRow) {
        const char = currentGuess[c] || "";
        tiles.push(
          <Tile key={c} char={char} mode={char ? "filled" : "empty"} />
        );
      } else {
        tiles.push(<Tile key={c} char="" mode="empty" />);
      }
    }

    rows.push(
      <div
        key={r}
        className={`grid grid-cols-5 gap-1.5 ${isShake ? "numex-row-shake" : ""}`}
        data-testid={`grid-row-${r}`}
      >
        {tiles}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1.5 w-full" data-testid="numex-grid">
      {rows}
    </div>
  );
}
